module.exports = __webpack_public_path__ + "img/material-symbols_check-box_yellow.c8642eca.svg";